import React, { useEffect, useState } from 'react';
import { supabase } from '../../supabase';
import './eventstable.css';

const EventsTable = () => {
    const [events, setEvents] = useState([]);

    const [showForm, setShowForm] = useState(false);

    const [form, setForm] = useState({
        title: '',
        subtitle: '',
        event_date: ''
    });

    const fetchEvents = async () => {
        const { data } = await supabase
            .from('events')
            .select('*')
            .order('created_at', { ascending: false });

        if (data) setEvents(data);
    };

    useEffect(() => {
        fetchEvents();
    }, []);
    const addEvent = async (e) => {
        e.preventDefault();

        const { error } = await supabase
            .from('events')
            .insert([
                {
                    title: form.title,
                    subtitle: form.subtitle,
                    event_date: form.event_date
                }
            ]);

        if (!error) {
            setForm({ title: '', subtitle: '', event_date: '' });
            setShowForm(false);
            fetchEvents();
        }
    };

    const deleteEvent = async (id) => {
        const confirmDelete = window.confirm("Delete this event?");
        if (!confirmDelete) return;

        const { error } = await supabase
            .from('events')
            .delete()
            .eq('id', id);

        if (!error) {
            setEvents(prev => prev.filter(e => e.id !== id));
        }
    };

    const editEvent = async (event) => {
        const newTitle = window.prompt("Edit title", event.title);
        const newSubtitle = window.prompt("Edit subtitle", event.subtitle);
        const newDate = window.prompt("Edit date", event.event_date);

        if (!newTitle || !newSubtitle || !newDate) return;

        const { error } = await supabase
            .from('events')
            .update({
                title: newTitle,
                subtitle: newSubtitle,
                event_date: newDate
            })
            .eq('id', event.id);

        if (!error) fetchEvents();
    };

    return (
        <div className="eventstable">

            <div className="etopbar">
                <h6 className="tabletitle">Events</h6>

                <button
                    className="addeventbt"
                    onClick={() => setShowForm(true)}
                    type="button"
                >
                    <div className="plus">+</div>
                    <span className="bttext">Add event</span>
                </button>
            </div>

            <div className="tableheader">
                <p>Title</p>
                <p>Subtitle</p>
                <p>Date</p>
                <p>Actions</p>
            </div>

            {events.map((event) => (
                <div className="tablerrow" key={event.id}>
                    <p>{event.title}</p>
                    <p>{event.subtitle}</p>
                    <p>{event.event_date}</p>

                    <div className="actions">
                        <button onClick={() => editEvent(event)}>Edit</button>
                        <button onClick={() => deleteEvent(event.id)}>Delete</button>
                    </div>
                </div>
            ))}
            {showForm && (
                <div className="modalOverlay">
                    <div className="modal">
                        <h3>Add Event</h3>

                        <form onSubmit={addEvent}>
                            <input
                                placeholder="Title"
                                value={form.title}
                                onChange={(e) =>
                                    setForm({ ...form, title: e.target.value })
                                }
                            />

                            <input
                                placeholder="Subtitle"
                                value={form.subtitle}
                                onChange={(e) =>
                                    setForm({ ...form, subtitle: e.target.value })
                                }
                            />

                            <input
                                type="date"
                                value={form.event_date}
                                onChange={(e) =>
                                    setForm({ ...form, event_date: e.target.value })
                                }
                            />

                            <div className="modalActions">
                                <button className='modalActionsadd'>Add</button>
                                <button
                                    className='modalActionscancel'
                                    onClick={() => setShowForm(false)}
                                >
                                    Cancel
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

        </div>
    );
};

export default EventsTable;